export const getStepperStyles = (isDarkMode: boolean) => {
  return {
    step: {
      fontSize: "1.8rem",
      fontWeight: 600,
    },
    stepLabel: {
      fontSize: "1.6rem",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
    },
    stepDescription: {
      fontSize: "1.2rem",
      color: isDarkMode ? "#f0f0f0" : "#b2b2b2",
    },
    separator: {
      backgroundColor: isDarkMode ? "#f0f0f0" : "#b2b2b2",
      height: "4px",
    },
    steps: {
      padding: "10px 0",
    },
    stepIcon: {
      backgroundColor: isDarkMode ? "#F0F0F0" : "transparent",
      color: isDarkMode ? "#201b41" : "#201b41",
      border: isDarkMode ? "2px solid #f0f0f0" : "2px solid #201b41",
    },
    stepCompletedIcon: {
      color: isDarkMode ? "#008001" : "#008001",
      backgroundColor: "transparent",
    },
  };
};
